@reference "~/styles.css";

@layer components {
	/* necessary to reset the default styles when using the `el` prop with `button` or `a` elements */
	.link {
		@apply p-0 border-0 outline-hidden inline bg-transparent aria-disabled:cursor-default;
	}

	.unstyled {
		@apply cursor-pointer text-inherit no-underline hover:text-inherit hover:no-underline focus-visible:no-underline focus-visible:text-inherit;
	}

	.primary {
		@apply cursor-pointer text-primary-600 transition-colors no-underline hover:text-inherit focus-visible:text-gray-800 aria-disabled:text-graphite-400 aria-disabled:hocus:text-graphite-400 aria-disabled:hocus:cursor-not-allowed;
	}

	.secondary {
		@apply cursor-pointer text-gray-800 underline hover:text-gray-800 hover:no-underline focus-visible:no-underline focus-visible:text-gray-800;
	}

	.tertiary {
		@apply cursor-pointer text-gray-800 font-normal text-13 underline hover:text-gray-800 hover:no-underline focus-visible:no-underline focus-visible:text-gray-800;
	}

	.light {
		@apply cursor-pointer text-white font-normal text-13 underline hover:no-underline hover:text-white focus-visible:no-underline focus-visible:text-white;
	}
}
